import { GlobalAxios } from "../axios/axios-config";

const route =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ExamManagementNotification/Reprocess";

export const reprocessExamManagementNotifications = ({
  ids,
}: {
  ids: string[];
}) => GlobalAxios.post(route, { ids });
